export class MemberInfo {
    uid?: string;

    name?: string;

    desc?: string;

    display_name?: string;

    email?: string;

    mobile?: string;

    mobile_area?: string;

    short_code?: string;

    avatar?: string;

    display_name_pinyin?: string;

    role?: number;

    status?: number;
}

export class MemberDetailInfo extends MemberInfo {

    department?: { _id?: string, name?: string };

    department_name?: string;

    departments?: { _id?: string, name?: string }[];

    extension_fields?: any[];

    job?: {};

    preferences?: { locale: string };

    roles?: { _id?: string, desc?: string, type?: number, name?: string }[];

    team?: string;

    team_roles?: string[];

    title?: string;

}
